module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Consolidation - Export")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ffFclConsoModel.allModuleId ? _vm.ffFclConsoModel.allModuleId : '',
      "jobSeriesBanner": _vm.ffFclConsoModel.ffExportFclConsoSeries ?
        _vm.ffFclConsoModel.ffExportFclConsoSeries :
        '',
      "bannerClientName": _vm.ffFclConsoModel.clientName ? _vm.ffFclConsoModel.clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [(_vm.ffFclConsoModel.ffFclConsoExportId != '') ? _c('md-button', {
    staticClass: "md-fab",
    on: {
      "click": _vm.addStatus
    }
  }, [_c('md-icon', {
    staticClass: "icon-1"
  }, [_vm._v("message")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('StatusAlerts', {
    attrs: {
      "SUBS_alerts": _vm.SUBSAlerts
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select FF Activity",
      "isDisabled": _vm.ExecutionDisable == '' ? false : true
    },
    model: {
      value: (_vm.ffFclConsoModel.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "containerInfo", $$v)
      },
      expression: "ffFclConsoModel.containerInfo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffFclConsoModel.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "shippingId", $$v)
      },
      expression: "ffFclConsoModel.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.shippingId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("Stuffing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeList,
      "isDisabled": "",
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type"
    },
    model: {
      value: (_vm.ffFclConsoModel.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "stuffingType", $$v)
      },
      expression: "ffFclConsoModel.stuffingType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.ffFclConsoModel.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "deliveryMode", $$v)
      },
      expression: "ffFclConsoModel.deliveryMode"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.deliveryMode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.deliveryMode))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Container Type/Size")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "list": _vm.ContainerTypeList,
      "placeholder": "Select Container Type/Size"
    },
    on: {
      "input": function($event) {
        _vm.getContainerTypeDet(_vm.ffFclConsoModel.containerTypeId)
      }
    },
    model: {
      value: (_vm.ffFclConsoModel.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "containerTypeId", $$v)
      },
      expression: "ffFclConsoModel.containerTypeId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.containerTypeId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("COUNT of CONTAINERS"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "no_of_container",
      "name": "no_of_container"
    },
    model: {
      value: (_vm.ffFclConsoModel.no_of_container),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "no_of_container", $$v)
      },
      expression: "ffFclConsoModel.no_of_container"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.no_of_container) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.no_of_container))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Source of Booking")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipTypeList,
      "option-value": "shipTypeVal",
      "option-text": "shipTypeText",
      "placeholder": "Select Source"
    },
    model: {
      value: (_vm.ffFclConsoModel.shipType),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "shipType", $$v)
      },
      expression: "ffFclConsoModel.shipType"
    }
  })], 1), _vm._v(" "), (_vm.ffFclConsoModel.containerInfo == 'LclConsolidation') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Enter Co-­Loader Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "coloaderName",
      "name": "coloaderName"
    },
    model: {
      value: (_vm.ffFclConsoModel.coloaderName),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "coloaderName", $$v)
      },
      expression: "ffFclConsoModel.coloaderName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffFclConsoModel.shipType != '') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "bookingSourceclientId"
    }
  }, [_vm._v("Booking\n                Party")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Booking Party"
    },
    model: {
      value: (_vm.ffFclConsoModel.bookingSourceclientId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "bookingSourceclientId", $$v)
      },
      expression: "ffFclConsoModel.bookingSourceclientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": 'Select Agent Name'
    },
    on: {
      "input": _vm.getAgentDetails
    },
    model: {
      value: (_vm.ffFclConsoModel.agentName),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "agentName", $$v)
      },
      expression: "ffFclConsoModel.agentName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Buyer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyer",
      "name": "buyer"
    },
    model: {
      value: (_vm.ffFclConsoModel.buyer),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "buyer", $$v)
      },
      expression: "ffFclConsoModel.buyer"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port_India', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Icd,Sea_Port_India', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffFclConsoModel.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "PORlocationId", $$v)
      },
      expression: "ffFclConsoModel.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.PORlocationId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name",
      "isError": _vm.ffFclConsoModel.portType == 'Icd' ? false : true
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffFclConsoModel.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "LPlocationId", $$v)
      },
      expression: "ffFclConsoModel.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.LPlocationId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Free Time At Origin(In Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "freeTimeAtOrigin",
      "name": "freeTimeAtOrigin"
    },
    model: {
      value: (_vm.ffFclConsoModel.freeTimeAtOrigin),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "freeTimeAtOrigin", $$v)
      },
      expression: "ffFclConsoModel.freeTimeAtOrigin"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getPortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ffFclConsoModel.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "PODLocationId", $$v)
      },
      expression: "ffFclConsoModel.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.PODLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port_NonIndia', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffFclConsoModel.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "finalPlaceLocationId", $$v)
      },
      expression: "ffFclConsoModel.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffFclConsoModel.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffFclConsoModelError.finalPlaceLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Free Time At Destination(Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "freeTimeAtDestination",
      "name": "freeTimeAtDestination"
    },
    model: {
      value: (_vm.ffFclConsoModel.freeTimeAtDestination),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "freeTimeAtDestination", $$v)
      },
      expression: "ffFclConsoModel.freeTimeAtDestination"
    }
  })], 1), _vm._v(" "), (_vm.ffFclConsoModel.portType == 'Icd') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "pdaDetail"
    }
  }, [_vm._v("PDA Details")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pdaDetailList,
      "option-value": "pdaDetailsVal",
      "option-text": "pdaDetailsText",
      "placeholder": "Select PDA ",
      "isDisabled": _vm.ExecutionDisable == '' ? false : true
    },
    model: {
      value: (_vm.ffFclConsoModel.pdaDetail),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "pdaDetail", $$v)
      },
      expression: "ffFclConsoModel.pdaDetail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.newJobType.indexOf('CC') >= 0) ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffFclConsoModel.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "ccType", $$v)
      },
      expression: "ffFclConsoModel.ccType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffFclConsoModel.ccType == 'Outsourced') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffFclConsoModel.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "ccCha", $$v)
      },
      expression: "ffFclConsoModel.ccCha"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffFclConsoModel.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffFclConsoModel, "remark", $$v)
      },
      expression: "ffFclConsoModel.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.showClientDiv == true || _vm.ffFclConsoModel.ffFclConsoExportId == '') ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v("Multiple Client Details")])])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Shipper Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Shipper Name"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.clientId),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "clientId", $$v)
      },
      expression: "fclConsoMultipleModel.clientId"
    }
  }), _vm._v(" "), (!_vm.fclConsoMultipleModel.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.fclConsoMultipleModelError.clientId))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "deliveryTerms", $$v)
      },
      expression: "fclConsoMultipleModel.deliveryTerms"
    }
  }), _vm._v(" "), (!_vm.fclConsoMultipleModel.deliveryTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.fclConsoMultipleModelError.deliveryTerms))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity-HSN Code")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemHSNCode",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.fclConsoMultipleModel.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "commodityId", $$v)
      },
      expression: "fclConsoMultipleModel.commodityId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "commodityType", $$v)
      },
      expression: "fclConsoMultipleModel.commodityType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openCommodityModal()
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), (_vm.fclConsoMultipleModel.commodityType == 'Reefer') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree\n                Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "temperatureRequired", $$v)
      },
      expression: "fclConsoMultipleModel.temperatureRequired"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fclConsoMultipleModel.commodityType == 'Others') ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Specific Detail if\n                any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "otherComodity", $$v)
      },
      expression: "fclConsoMultipleModel.otherComodity"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fclConsoMultipleModel.commodityType == 'Hazardous') ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "IMDGClass", $$v)
      },
      expression: "fclConsoMultipleModel.IMDGClass"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "UNNumber", $$v)
      },
      expression: "fclConsoMultipleModel.UNNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "packingCode", $$v)
      },
      expression: "fclConsoMultipleModel.packingCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v("Additional Task")])])])]), _vm._v(" "), _vm._l((_vm.showOtherServiceArray), function(otherServiceNameArray, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "cols": "3"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": otherServiceNameArray.value,
        "name": 'otherServices' + (index + 1),
        "id": 'otherServices' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.otherServiceNameArraySelect(otherServiceNameArray.value, index)
        }
      },
      model: {
        value: (_vm.fclConsoMultipleModel.otherServices[index]),
        callback: function($$v) {
          _vm.$set(_vm.fclConsoMultipleModel.otherServices, index, $$v)
        },
        expression: "fclConsoMultipleModel.otherServices[index]"
      }
    }, [_vm._v(_vm._s(otherServiceNameArray.show))])], 1)
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_c('b', [_c('u', [_vm._v("More Additional Tas")])])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "additionalMoreTask"
    }
  }, [_vm._v("More Additional Task")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "placeholder": "Click for More Additional Task",
      "name": "additionalMoreTask",
      "id": "additionalMoreTask",
      "multiple": ""
    },
    on: {
      "change": _vm.showMultiple
    },
    model: {
      value: (_vm.fclConsoMultipleModel.additionalMoreTask),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "additionalMoreTask", $$v)
      },
      expression: "fclConsoMultipleModel.additionalMoreTask"
    }
  }, _vm._l((_vm.showAdditionalMoreTaskArray), function(AdditionalMoreArray, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": AdditionalMoreArray
      }
    }, [_vm._v(_vm._s(AdditionalMoreArray.show))])
  }))], 1)], 1), _vm._v(" "), (_vm.showAdd) ? _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', [_vm._v("Specify Additional Task")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "specificAdditionalTask",
      "name": "specificAdditionalTask"
    },
    model: {
      value: (_vm.fclConsoMultipleModel.specificAdditionalTask),
      callback: function($$v) {
        _vm.$set(_vm.fclConsoMultipleModel, "specificAdditionalTask", $$v)
      },
      expression: "fclConsoMultipleModel.specificAdditionalTask"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px mrgtop-2per",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "id": "addButtonLoaderMultiple"
    },
    on: {
      "click": _vm.addMultipleClient
    }
  }, [_vm._v(_vm._s(_vm.fclConsoMultipleModel.fclConsoMultipleClientId == "" ? "Add" : "Edit") + "\n                client")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderMultiple"
    }
  })], 1), _vm._v(" "), (_vm.FclConsoDetailArray.length > 0) ? _c('hr', {
    staticClass: "hr-border"
  }) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.FclConsoDetailArray.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Client Details")])]), _vm._v(" "), (this.showClientDiv == false) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.addMoreClient
    }
  }, [_vm._v("Add More Client")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "FreghtContaner"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Delievery Terms")]), _vm._v(" "), _c('th', [_vm._v("Commodity")]), _vm._v(" "), _c('th', [_vm._v("Additional Task")]), _vm._v(" "), _c('th', [_vm._v("More Additional Task")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.FclConsoDetailArray), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditMul(item1)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(item1.myclientName) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.deliveryTerms) + "\n                          "), (!item1.deliveryTerms) ? _c('p', {
      staticClass: "error"
    }, [_vm._v("\n                            Delivery Terms Field is Required!\n                          ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.commodityId) + "\n                          "), (item1.commodityId === '0') ? _c('p', {
      staticClass: "error"
    }, [_vm._v("\n                            Commodity Field is Required!\n                          ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.otherServices == "" ? "--" : item1.otherServices) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item1.moreAdditionalTask == "" ? "--" : item1.moreAdditionalTask) + "\n                        ")]), _vm._v(" "), _c('td', [(
      _vm.$sessionsStorage.get('designation') == 'Admin' &&
      _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
    ) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.removeCommon(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1) : _vm._e()], 1)])
  }))])])]) : _vm._e()]), _vm._v(" "), (_vm.FclConsoDetailArray.length > 0) ? _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderS"
    },
    on: {
      "click": _vm.ProceedBookingOrder
    }
  }, [_vm._v("Save & Proceed to\n                Booking")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderS"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffFclConsoModel.FFExportFCLCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffFclConsoModel.FFExportFCLCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffFclConsoModel.FFExportFCLUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffFclConsoModel.FFExportFCLUpdated))])]) : _vm._e()])], 2), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Commodity-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Commodity"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Item Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "itemName",
      "name": "itemName"
    },
    model: {
      value: (_vm.commodityModal.itemName),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "itemName", $$v)
      },
      expression: "commodityModal.itemName"
    }
  }), _vm._v(" "), (!_vm.commodityModal.itemName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.itemName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("HSN Code "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "hsnCode",
      "name": "hsnCode"
    },
    model: {
      value: (_vm.commodityModal.hsnCode),
      callback: function($$v) {
        _vm.$set(_vm.commodityModal, "hsnCode", $$v)
      },
      expression: "commodityModal.hsnCode"
    }
  }), _vm._v(" "), (!_vm.commodityModal.hsnCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorList.hsnCode))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addCommodity
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideCommodityModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopInsert",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.ProceedNext
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea10d6e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/ffExportFclConsolidation.vue
// module id = 2899
// module chunks = 0